var AppearanceSlider = /** @class */ (function () {
    function AppearanceSlider(manager, appearance) {
        this._manager = manager;
        this._appearance = appearance;
    }
    AppearanceSlider.prototype.show = function (widget, showCb) {
        return this._manager.show(widget, this._appearance, showCb);
    };
    AppearanceSlider.prototype.hide = function () {
        return this._manager.hide();
    };
    AppearanceSlider.prototype.destroy = function () {
        return this._manager.destroy(this._appearance);
    };
    AppearanceSlider.prototype.resize = function (state, size) {
        return this._manager.resize(this._appearance, size);
    };
    AppearanceSlider.prototype.canShow = function () {
        return this._manager.canShow();
    };
    return AppearanceSlider;
}());
export { AppearanceSlider };
